module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/Fb.a6dcf019.svg";